import React from 'react'
import IconsPath from '../assets/icons/index'
import LanguageTranslator from '../locals/LanguageTranslator'

const NewNoDataFound = (props) => {

  const {className=''} = props;

  return (
    <div className={`no-data-found-screen ${className}`}>
    <div className='ndfs-inner'>
      <IconsPath.NewNoDataFound />
      <LanguageTranslator tag="h3" className='!text-[13px] !mb-0'>{props?.primaryText || "No Result found !"}</LanguageTranslator>
      {props.secondaryText && (typeof(props.secondaryText) == "function" ? props.secondaryText() : <LanguageTranslator tag="p" className='!text-[#74767A] !text-[11px] !font-medium'>{props.secondaryText}</LanguageTranslator>)}
    </div>
  </div>
  )
}

export default NewNoDataFound